import {
    HttpErrorResponse,
    HttpInterceptorFn,
    HttpStatusCode
} from "@angular/common/http";
import { inject } from "@angular/core";
import { environment } from "@environments/environment";
import { catchError, switchMap, throwError } from "rxjs";
import { SKIP_AUTH_REFRESH } from "./auth.context";
import { AuthService } from "./auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    const secureReq = req.url.startsWith(environment.backendUrl)
        ? req.clone({ withCredentials: true })
        : req;

    return next(secureReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (
                error.status !== HttpStatusCode.Unauthorized ||
                secureReq.context.get(SKIP_AUTH_REFRESH)
            ) {
                return throwError(() => error);
            }

            return authService.refreshOnce().pipe(
                switchMap(() => next(secureReq)),
                catchError(() => {
                    authService.silentLogout();
                    return throwError(() => error);
                })
            );
        })
    );
};
